(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-gallery-image"] && !Shopify.designMode) return;
  try {
    
  function initMobileGallerySlider() {
  var $gallery = $('.gallery-slider');

  // Only initialize on mobile
  if ($(window).width() < 768) {
    if (!$gallery.hasClass('slick-initialized')) {
      $gallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        adaptiveHeight: false,
      });
    }
  } else {
    // Destroy slick if resized to desktop
    if ($gallery.hasClass('slick-initialized')) {
      $gallery.slick('unslick');
    }
  }
}

// Run on page load and resize
$(document).ready(initMobileGallerySlider);
$(window).on('resize', function() {
  setTimeout(initMobileGallerySlider, 300);
});


  } catch(e) { console.error(e); }
})();
})();
